// extracted by mini-css-extract-plugin
export var optionGrid = "_2q-7";
export var optionList = "_2q-6";
export var questionsBlock = "_2q-9";
export var spacer = "_2q-5";
export var stepCenteredContent = "_2q-3";
export var stepInner = "_2q-0";
export var stepInnerFullWidth = "_2q-1";
export var stepInnerLockScroll = "_2q-2";
export var stepTransitionFrame = "_2q-4";
export var welcomeBlock = "_2q-8";